const ipfsProtocolPattern = new RegExp("^ipfs://(ipfs/)?", "i");

export function formatGatewayUri(
  uri: string,
  ipfsGateway: string | null | undefined
) {
  if (!ipfsGateway) {
    // We have not gateway, so we can't reformat the uri
    return uri;
  }

  return uri.replace(ipfsProtocolPattern, `${ipfsGateway}ipfs/`);
}
